import { render, staticRenderFns } from "./Hypnosis.vue?vue&type=template&id=3704467e&scoped=true&"
import script from "./Hypnosis.vue?vue&type=script&lang=js&"
export * from "./Hypnosis.vue?vue&type=script&lang=js&"
import style0 from "./Hypnosis.vue?vue&type=style&index=0&id=3704467e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3704467e",
  null
  
)

export default component.exports